module.exports = __webpack_public_path__ + "img/logout.5b27a382.svg";